import React, { useMemo, useState } from 'react';
import Styles from './LeilaoDeVeiculosDatas.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import SearchableDropdown from '../../atoms/SearchableDropdown';
import { DatasLeiloes } from './DatasLeiloes';
import SearchableDropdownV2 from '@/components/atoms/SearchableDropdown/SearchableDropdownV2';

function LeilaoDeVeiculosDatas() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }

  const [value, setValue] = useState();
  const cidades = useMemo(() => {
    if (!value) return [];
    return DatasLeiloes.find((d) => d.name === value)?.cidades ?? [];
  }, [value]);
  return (
    <>
      <section id="leilao-de-veiculos-datas">
        {typeof window === 'undefined' ? (
          <></>
        ) : (
          <>
            {width < 992 && (
              <img src="assets/leilao-de-veiculos/img-datas.svg" alt="" className="img-datas" />
            )}
          </>
        )}
        <ContainerHome24>
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width >= 992 && (
                <img
                  src="assets/leilao-de-veiculos/img-datas-desk.svg"
                  alt=""
                  className="img-datas"
                />
              )}
            </>
          )}
          <div>
            <h2 className="leilao-de-veiculos-datas-titulo">Próximos leilões</h2>
            <p className="leilao-de-veiculos-datas-texto">
              Confira onde e quando os próximos leilões serão realizados, com leiloeiros homologados
              pelo Santander*.
            </p>
            <SearchableDropdownV2
              optionsContainerId={'dropdown-select-state'}
              options={DatasLeiloes}
              label="name"
              id="stateName"
              name="stateName"
              onValueChanged={(val) => {
                setValue(val);
              }}
              placeholder="Selecionar estado"
              autoSelect
            />
            {cidades &&
              cidades.map((cidade) => (
                <div key={cidade.nameCidade} className="datas-cidades">
                  <p className="datas-cidades-titulo">
                    <b>{cidade.nameCidade}</b>
                    <br />
                    {cidade.leiloeiro}
                  </p>
                  <p className="datas-cidades-endereco">
                    {cidade.endereco}
                    <br />
                    Datas: {cidade.datas}
                    <br />
                    <br />
                    <a href={cidade.url} target="_blank">
                      {cidade.site}
                    </a>
                  </p>
                </div>
              ))}
          </div>
        </ContainerHome24>
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default LeilaoDeVeiculosDatas;
